var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5671 5.08378V10.3724C1.6452 11.3833 1.72255 12.7058 1.80066 13.6393C1.87801 14.7283 2.81152 15.5837 3.90125 15.5837H9.65624C10.7452 15.5837 11.678 14.7283 11.7568 13.6393C11.8342 12.7065 11.9115 11.384 11.9896 10.3724C12.067 9.20608 11.9896 6.79458 11.9896 5.08378H1.5671ZM12.2232 2.75038H10.2781L9.65624 1.58331C9.26721 0.883367 8.56727 0.416992 7.78922 0.416992H5.92296C5.14491 0.416992 4.36686 0.883367 4.05595 1.58331L3.27865 2.75038H1.33353C1.02261 2.75038 0.710938 3.0613 0.710938 3.37222C0.710938 3.68313 1.02185 3.99481 1.33277 3.99481H12.2224C12.5334 3.99481 12.8443 3.76124 12.8443 3.37298C12.8443 2.98471 12.5341 2.75038 12.2232 2.75038ZM4.60043 2.75038L4.98945 2.12855C5.14491 1.81763 5.45583 1.58331 5.84485 1.58331H7.71187C8.1009 1.58331 8.41181 1.73953 8.56727 2.12779L8.9563 2.74963L4.60043 2.75038Z",
    fill: "#E00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDelete);
export default __webpack_public_path__ + "static/media/menu-delete.7141ce345a6be0104e53e7e55102556c.svg";
export { ForwardRef as ReactComponent };